import { clearLocalStorage, getLocalStorage, setLocalStorage } from '@nordvpn/teams.core/lib/tools/localStorageService';
import { STORAGE_NAME_AUTH } from './constants';
export var storeAuthDataToLocalStorage = function storeAuthDataToLocalStorage(authData) {
    var formattedData = {
        token: authData.token,
        expiresAt: authData.expires_at,
        renewToken: authData.renew_token,
        renewTokenExpiresAt: authData.renew_expires_at,
        rememberMe: !!authData.remember_me,
        mfaToken: authData.mfa_token,
        error: undefined
    };
    setLocalStorage(STORAGE_NAME_AUTH, formattedData);
};
export var getUserToken = function getUserToken() {
    var auth = getLocalStorage(STORAGE_NAME_AUTH);
    return (auth === null || auth === void 0 ? void 0 : auth.token) || '';
};
export var clearAuthDataFromLocalStorage = function clearAuthDataFromLocalStorage() {
    clearLocalStorage(STORAGE_NAME_AUTH);
};
